import React, { useEffect } from 'react'

import { useTheme } from '@gousto-internal/citrus-react'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import { useCurrentCollectionId, useCollections } from 'hooks/menu-collections'
import { useDoubleDeckerNav } from 'hooks/useDoubleDeckerNav'
import { useBasket } from 'routes/Menu/domains/basket'
import { getHasProspectNotSeenWizard } from 'routes/Menu/selectors/menu'

import { useChangeCollectionById } from '../../domains/collections'
import { CollectionsNav } from './CollectionsNav'
import { useTracking } from './useTracking'

import css from './CollectionsNav.css'

type CollectionsNavWrapperProps = {
  user: {
    nameFirst: string
  }
}

const CollectionsNavWrapper = (ownProps: CollectionsNavWrapperProps) => {
  const { theme } = useTheme()
  const hasProspectNotSeenWizard = useSelector(getHasProspectNotSeenWizard)
  const currentCollectionId = useCurrentCollectionId()
  const collections = useCollections()
  const changeCollectionById = useChangeCollectionById()
  const { menuId } = useBasket()
  const doubleDeckerExperimentEnabled = useDoubleDeckerNav()
  const mobileBreakpoint = Number.parseInt(theme.tokens.breakpoints[1], 10)

  const track = useTracking({ menuId, collections })
  useEffect(() => track(), [track])

  return (
    <div
      className={classnames({
        [css.doubleDeckerCollectionsNavWrapper]: doubleDeckerExperimentEnabled,
      })}
    >
      <CollectionsNav
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...ownProps}
        hasProspectNotSeenWizard={hasProspectNotSeenWizard}
        changeCollectionById={changeCollectionById}
        menuCollections={collections}
        menuCurrentCollectionId={currentCollectionId}
        doubleDeckerExperimentEnabled={doubleDeckerExperimentEnabled}
        mobileBreakpoint={mobileBreakpoint}
      />
    </div>
  )
}

export { CollectionsNavWrapper }
